import { apiRoutes } from "../constants/config";
import { getAuthHeader } from './api'; // Assuming getAuthHeader is in this path

export const exportContentId34Data = async (startDate, endDate, tz, format = "csv", allBlendshapes = false) => {
    try {
        const url = apiRoutes.exportContentId34Data(startDate, endDate, tz, format, allBlendshapes);
        const headers = await getAuthHeader();
        // headers.append("Content-Type", "application/json"); // Not strictly needed for a GET request that accepts CSV/JSON based on query param

        console.log('Calling export ContentId34 Data API:', { url });
        
        const response = await fetch(url, {
            method: 'GET',
            headers,
        });
        
        if (!response.ok) {
            // Handle HTTP errors
            const errorData = await response.json().catch(() => ({ message: response.statusText }));
            console.error('Error exporting ContentId34 data:', errorData);
            throw new Error(errorData.message || 'Failed to export data');
        }

        // Depending on the expected response type and how you want to handle it:
        // If you always expect a blob (file download):
        // return await response.blob(); 

        // Or if you expect JSON and handle blob/file download elsewhere:
        if (format === 'json') {
            return await response.json();
        } else {
            // For CSV, you might want to return the text or handle as a blob
            // For simplicity, returning text, but blob might be more appropriate for direct download
            return await response.text();
        }

    } catch (error) {
        console.error('Error in exportContentId34Data function:', error);
        throw error;
    }
}; 